var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FORGOT_PASSWORD_ERROR_ACTION_TYPE, FORGOT_PASSWORD_RESET_ACTION_TYPE, FORGOT_PASSWORD_SEND_START_ACTION_TYPE, FORGOT_PASSWORD_SEND_SUCCESS_ACTION_TYPE, FORGOT_PASSWORD_UNKNOWN_EMAIL_ACTION_TYPE, } from "../action/ForgotPasswordActionsTypes";
import { ForgotPasswordStatus } from "./ForgotPasswordState";
var initialState = {
    status: ForgotPasswordStatus.Initial,
    email: "",
};
export var forgotPasswordReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case FORGOT_PASSWORD_RESET_ACTION_TYPE:
            return __assign({}, initialState);
        case FORGOT_PASSWORD_SEND_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: ForgotPasswordStatus.Sending, email: action.payload.email });
        case FORGOT_PASSWORD_SEND_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: ForgotPasswordStatus.SendSuccess });
        case FORGOT_PASSWORD_UNKNOWN_EMAIL_ACTION_TYPE:
            return __assign(__assign({}, state), { status: ForgotPasswordStatus.UnknowEmail });
        case FORGOT_PASSWORD_ERROR_ACTION_TYPE:
            return __assign(__assign({}, state), { status: ForgotPasswordStatus.Error });
        default:
            return state;
    }
};
export default forgotPasswordReducer;
